import React from 'react';
import '../../components/css/popupstyle.css';
import { userService } from '../../_services';
import $ from 'jquery';
import DeleteIcon from '../.././components/css/dark/img/delete.svg';
import EditIcon from '../.././components/css/dark/img/edit2.svg';
import GroupSection from '../../components/Admin/WhManageGroup';

class AddOverride extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: '',
            successMsg: '',
            userdata: JSON.parse(localStorage.getItem('user')),
            loader: true,
            ChainNamesList: [],
            UserList_ut: [],
            overrides: [],
            tempOverrides: {},
            btnLoader: false,
            overridesStatus: '',
            noInitialOverrides: true,
            isChecked: false,
            isPreGroupSpecific: false,
            showGroupSection: false, //
            predefinedGroups: null
        }
        this.add_override_row = this.add_override_row.bind(this);
        this.handleChange_overrides_user = this.handleChange_overrides_user.bind(this);
        this.handleChange_overrides_commission = this.handleChange_overrides_commission.bind(this);
    }
    componentDidMount() {
        this.fetchPharmacyChainList();
        this.fetchUserPharmacyChainList(this.props.whName, this.props.whId);
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
    }

    handleResponse = (response) => {
        return response.text().then(text => {
            try {
                return text ? JSON.parse(text) : {};
            } catch (error) {
                console.error("JSON parse error:", error);
                return Promise.reject("Invalid JSON response");
            }
        });
    };

    fetchPharmacyChainList() {
        try {
            userService.fetchPharmacyChainList('a', 'a')
                .then(response => this.handleResponse(response))
                .then(data => {
                    this.setState({ loader: false, ChainNamesList: data, btnLoader: false });
                })
                .catch(error => {
                    console.error("Fetch error:", error);
                    this.setState({ loader: false, error: 'Oops! Something went wrong. Try Again.', btnLoader: false });

                    setTimeout(() => {
                        this.setState({ error: '', successMsg: '' })
                    }, 3000)
                });
        } catch (error) {
            this.setState({ loader: false, error: 'Oops! Something went wrong. Try Again.', btnLoader: false });
            setTimeout(() => {
                this.setState({ error: '', successMsg: '' })
            }, 3000)
        }
    }
    fetchUserPharmacyChainList(whname, wholesaler_Id) {
        try {
            userService.fetchUserPharmacyChainList(whname, wholesaler_Id, 0)
                .then(response => this.handleResponse(response))
                .then(data => {
                    if (data[0].isGroupSpecific) {
                        this.setState({ loader: false, overrides: data[0].chainNames, btnLoader: false, noInitialOverrides: data && data[0].chainNames && data[0].chainNames.length ? false : true, isChecked: true, isPreGroupSpecific: true, predefinedGroups: data[0].groupNumbers });
                    } else {
                        this.setState({ loader: false, overrides: data[0].chainNames, btnLoader: false, noInitialOverrides: data && data[0].chainNames && data[0].chainNames.length ? false : true, isChecked: false });
                    }
                })
                .catch(error => {
                    console.error("Fetch error:", error);
                    this.setState({ loader: false, btnLoader: false, error: 'Oops! Something went wrong. Try Again.' });
                    setTimeout(() => {
                        this.setState({ error: '', successMsg: '' })
                    }, 3000)
                });
        }
        catch (error) {
            this.setState({ loader: false, btnLoader: false, error: 'Opps!, Something went wrong. Try Again.' });
            setTimeout(() => {
                this.setState({ error: '', successMsg: '' })
            }, 3000)
        }
    }

    add_override_row(event) {
        try {
            const chainData = this.state.overrides && this.state.overrides.length ? [...this.state.overrides] : []
            if (this.state.overrides != null && this.state.overrides.length > 0) {
                const prevRow = chainData[chainData.length - 1]
                const hasChainName = !userService.Check_Null_Empty(prevRow.chainName);
                const hasComm = !userService.Check_Null_Empty(prevRow.comm);
                if (hasChainName && hasComm) {
                    prevRow.editable = false
                    let rowdata = { chainName: '', comm: "", editable: true };
                    chainData.forEach((row, index) => {
                        row.editable = false;
                    });
                    this.setState({ overrides: [...chainData, rowdata], error: '' });
                } else {
                    this.setState({ error: 'Please fill or save previous fields first' });
                }
            }
            else {
                const chainData = [];
                let rowdata = { chainName: '', comm: "", editable: true };
                chainData.forEach((row, index) => {
                    row.editable = false;
                });
                this.setState({ overrides: [...chainData, rowdata], error: '' });

            }
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }

    handlecancel = (e) => {
        try {
            this.setState({ error: '', btnLoader: false, loader: false });
            let overrideData = [...this.state.overrides];
            let rowIndex = e.target.closest('tr').getAttribute('dataIndex');
            let name = e.target.parentElement.parentElement.children[0].children[0].children[0].value;
            let commission = e.target.parentElement.parentElement.children[1].children[0].children[0].value;
            let rowData = overrideData[rowIndex];
            if (!rowData) return
            const hasChainName = !userService.Check_Null_Empty(name);
            const hasOverrideChainName = !userService.Check_Null_Empty(rowData.chainName);
            const hasComm = !userService.Check_Null_Empty(commission);
            const hasOverrideComm = !userService.Check_Null_Empty(rowData.comm);

            if (!hasChainName && !hasComm && !hasOverrideChainName && !hasOverrideComm) {
                overrideData.splice(rowIndex, 1);
            } else if (hasChainName && hasComm && hasOverrideChainName && hasOverrideComm) {
                name = rowData.chainName;
                commission = rowData.comm;
                rowData.editable = false;
            } else {
                rowData.editable = false;
            }

            this.setState({ overrides: overrideData });
        }
        catch (error) {
            this.setState({ error: 'Error, Try again', btnLoader: false });
        }
    }
    handleChange_overrides_user(e) {
        try {
            //let overrideData = this.state.overrides;
            let chainListName = $(e.target).attr('chName');
            //let rowIndex = $(e.target).attr('chIndex');

            e.target.parentElement.parentElement.children[0].value = chainListName;
            $(e.target).parents().removeClass('open');

            //e.target.parentElement.nextSibling.textContent = chainListName;
            //overrideData[rowIndex].chainName = chainListName;
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    handleChange_overrides_commission(e) {
        try {
            //let overrideData = this.state.overrides;
            let chainListCommission = e.target.value;
            //let rowIndex = $(e.target).attr('chIndex');
            e.target.parentElement.parentElement.children[0].children[0].value = chainListCommission;
            //e.target.nextSibling.textContent = chainListCommission;
            //overrideData[rowIndex].comm = chainListCommission;
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    handleClose = () => {
        try {
            this.props.closeAddOverridePopup(this.props.whName, this.props.whId, this.props.whPrefix, this.props.whProfilePagin, this.props.whSearch);
            this.props.openEditProfilePopup(this.props.whName, this.props.whId, this.props.whPrefix, this.props.whProfilePagin, this.props.whSearch);
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    cancelList = (e, index) => {
        try {
            const overrideData = this.state.overrides
            overrideData.splice(index, 1)
            this.setState({ overrides: overrideData })
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    saveData = (e) => {
        try {
            // get input field values
            let name = e.target.parentElement.parentElement.children[0].children[0].children[0].value;
            let commission = e.target.parentElement.parentElement.children[1].children[0].children[0].value;
            let currentIndex = e.target.parentElement.parentElement.getAttribute("dataIndex");
            if (!userService.Check_Null_Empty(name) && !userService.Check_Null_Empty(commission) && userService.validateCurrency(commission)) {
                if (commission > 10) {
                    this.setState({ error: 'Commission should not be more than 10', loader: false, btnLoader: false });
                } else if (commission <= 0) {
                    this.setState({ error: 'Commission should be more than 0', loader: false, btnLoader: false });
                } else {
                    e.target.parentElement.parentElement.classList.remove("ineditable");
                    let overrideData = this.state.overrides;
                    overrideData.splice(currentIndex, 1, { chainName: name, comm: commission, editable: false });
                    this.setState({ error: '', overrides: overrideData });
                }
            } else {
                this.setState({ error: "Fields can't be blank and commission should be a numeric value e.g. 0.10" });
            }
            setTimeout(() => {
                this.setState({ error: '', successMsg: '' })
            }, 3000)
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
            setTimeout(() => {
                this.setState({ error: '', successMsg: '' })
            }, 3000)
        }
    }
    handleEdit = (e) => {
        try {
            let overrideData = [...this.state.overrides];
            let name = e.target.parentElement.parentElement.children[0].children[0].children[0].value;
            let commission = e.target.parentElement.parentElement.children[1].children[0].children[0].value;
            let currentRowIndex = e.target.closest('tr').getAttribute('dataIndex');
            overrideData.forEach((row, index) => {
                if (index !== parseInt(currentRowIndex)) {
                    row.editable = false;
                }
            });

            // Make current row editable
            name = overrideData[currentRowIndex].chainName;
            commission = overrideData[currentRowIndex].comm;
            overrideData[currentRowIndex].editable = true;

            this.setState({ overrides: overrideData });
            //e.target.parentElement.parentElement.classList.add("ineditable");
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
            setTimeout(() => {
                this.setState({ error: '', successMsg: '' })
            }, 3000)
        }
    }
    showList = (e) => {
        try {
            e.target.nextElementSibling.classList.add('open');
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    hideList = (e) => {
        try {
            setTimeout(() => {
                $('.first-one ul').removeClass('open');
            }, 500);
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    keyPress = (e) => {
        try {
            const inputValue = e.target.value.toLowerCase();
            const ulElement = e.target.nextElementSibling; // Ensure it's the <ul>

            if (ulElement && ulElement.tagName === "UL") {
                const liElements = ulElement.querySelectorAll("li");

                if (inputValue.length > 0) {
                    ulElement.classList.add("open");

                    this.state.ChainNamesList.forEach((item, i) => {
                        if (item.chainName.toLowerCase().includes(inputValue)) {
                            liElements[i].style.display = "block";
                        } else {
                            liElements[i].style.display = "none";
                        }
                    });
                } else {
                    ulElement.classList.remove("open");
                    liElements.forEach(li => (li.style.display = "block")); // Show all if input is empty
                }
            }
        } catch (error) {
            this.setState({ error: "Error, Try again" });
        }
    };

    handleSaveSubmit = (e) => {
        this.setState({ btnLoader: true, loader: true });
        try {
            const isEditMode = this.state.overrides.some(row => row.editable === true);
            if (isEditMode) {
                this.setState({ error: 'Please save all the fields first', btnLoader: false, loader: false });
                return false;
            } else {
                let overrideData = [...this.state.overrides].map((item) => ({ ChainName: item.chainName, Comm: item.comm }));
                if (overrideData.length > 0)
                    this.saveOverrides(overrideData);
                else
                    this.setState({ error: 'Please add pharmacy chain list', btnLoader: false, loader: false });
                return false;
            }
        }
        catch (error) {
            this.setState({ error: 'Error, Try again', btnLoader: false, loader: false });
        }
    }
    saveOverrides(overrideData) {
        $(".button-section .save").attr("disabled", "true");
        try {
            const flag = this.state.noInitialOverrides ? 0 : 1
            userService.updatePharmacyChainList(overrideData, this.props.whName, this.props.whId, flag)
                .then(data => {
                    if (data.length > 0) {
                        if (data[0].status_code == "1") {
                            this.setState({ loader: false, btnLoader: false, successMsg: data[0].status_message });
                            $(".button-section .save").removeAttr("disabled");
                            this.fetchUserPharmacyChainList(this.props.whName, this.props.whId)
                            setTimeout(() => {
                                this.setState({ successMsg: '' })
                            }, 3000)
                        }
                        else {
                            this.setState({ loader: false, btnLoader: false, error: data[0].status_message });
                            setTimeout(() => {
                                this.setState({ successMsg: '', error: '' })
                            }, 3000)
                            $(".button-section .save").removeAttr("disabled");
                            //this.fetchUserPharmacyChainList(this.props.whName, this.props.whId)
                        }
                    }
                    else {
                        $(".button-section .save").removeAttr("disabled");
                        this.setState({ loader: false, btnLoader: false, error: 'Oops! Something went wrong. Try Again.' });
                        setTimeout(() => {
                            this.setState({ error: '' })
                        }, 3000)
                    }
                })
                .catch(error => {
                    $(".button-section .save").removeAttr("disabled");
                    this.setState({ loader: false, btnLoader: false, error: 'Oops! Something went wrong. Try Again.' });
                    setTimeout(() => {
                        this.setState({ error: '' })
                    }, 3000)
                });
        }
        catch (error) {
            this.setState({ loader: false, error: 'Opps!, Something went wrong. Try Again.', btnLoader: false });
            $(".button-section .save").removeAttr("disabled");
            setTimeout(() => {
                this.setState({ error: '' })
            }, 3000)
        }
    }
    handleCheckboxChange = () => {
        this.setState((prevState) => ({
            isChecked: !prevState.isChecked,
        }));
    };
    handleAddGroupSectionButtonClick = () => {
        this.props.closeAddOverridePopup(this.props.whName, this.props.whId, this.props.whPrefix, this.props.whProfilePagin, this.props.whSearch);
        this.props.openmanageGroupSection(this.props.whName, this.props.whId, this.props.whPrefix, this.props.whProfilePagin, this.props.whSearch);
    };
    handleCloseGroupSection = () => {
        this.setState({ showGroupSection: false });
    };
    render() {
        const { loader, error, overrides, ChainNamesList, btnLoader, successMsg } = this.state;
        let disabled = false;
        disabled = this.state.loader ? true : false;
        return (
            <div className='popup mfp-zoom-in override-content admin-popup whOverride-popup chainList-popup'>
                <div className='popup_inner manage-distributor-design'>
                    {loader &&
                        <div className="theme-loader"></div>
                    }

                    <h1>{this.props.text}<button onClick={this.handleClose}>X </button></h1>

                    <div className="wholesaler-section">
                        <form className="add-wh-form">
                            <div className="login-hub-section">

                                <div className="override-section milestone differ">
                                    <div className="right">
                                        <div className="popup-header">
                                            <div className="left-popup-header">
                                                <h2 className="adding-override">Chain List</h2>
                                                {/*----------------------adding Make Group Specific Checkbox*/}
                                                <div className="checkbox" onClick={this.state.isChecked || (!this.state.isChecked && !overrides.length) ? this.handleCheckboxChange : null} style={{ pointerEvents: this.state.isChecked || (!this.state.isChecked && !overrides.length) ? '' : 'none', opacity: this.state.isChecked || (!this.state.isChecked && !overrides.length) ? '' : '0.8' }}>
                                                    <input
                                                        type="checkbox" checked={this.state.isChecked} />
                                                    <span className="checkmark"></span>
                                                    Make Group Specific
                                                </div>
                                                <div className="selected-items" style={{ marginTop: '10px' }}>
                                                    {
                                                        this.state.predefinedGroups && this.state.predefinedGroups.length > 0 ?
                                                            <div className="selected-filters">
                                                                <label>Group Numbers:</label>
                                                                <div className="selectFilter">
                                                                    {this.state.predefinedGroups.map((item, index) => <div className="selected-filter-name" key={index}>
                                                                        <span className="group-name">{item.groupNumber}</span>
                                                                    </div>)}
                                                                </div>
                                                            </div> : null
                                                    }
                                                </div>
                                            </div>
                                            {this.state.isChecked && (
                                                <button id="btn_AddGroupSection" className="add-new" type="button" style={{ fontWeight: '400' }} onClick={this.handleAddGroupSectionButtonClick} style={{ marginLeft: '10px', fontWeight: 400 }}>{this.state.isPreGroupSpecific ? 'Edit' : 'Add'} Group Section</button>
                                            )}
                                        </div>
                                        <React.Fragment>
                                            {!this.state.isChecked ? <button id="lastChance" className="add-new" type="button" onClick={disabled ? null : this.add_override_row} style={{ fontWeight: '400' }}>Add New Chain</button> : null}
                                            {
                                                overrides != null && overrides.length > 0 ?
                                                    <table className="override-added">
                                                        <thead>
                                                            <tr className="header Sub">
                                                                <th className="first-one">Name</th>
                                                                <th className="third-one">Commission</th>
                                                                {!this.state.isChecked ? <th className="fourth-one">Actions</th> : null}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                overrides.map((grouprow, index) =>
                                                                    <tr className={grouprow.editable ? "milestoneData ineditable" : "milestoneData"} dataIndex={index}>
                                                                        <td className="first-one">
                                                                            <div className="formgroup" key={grouprow.id}>
                                                                                <input type="text" defaultValue={grouprow.chainName} autoComplete={'off'} onFocus={this.showList} onBlur={this.hideList} className="namefield_ form-control" name="overrides_name" onKeyUp={this.keyPress} />
                                                                                <ul>
                                                                                    {ChainNamesList.map((item, index) => <li key={index} onClick={this.handleChange_overrides_user.bind(this)} chName={item.chainName} chComm={item.commission} chIndex={index}>{item.chainName}</li>)}
                                                                                </ul>
                                                                                <span>{grouprow.chainName}</span>
                                                                            </div>
                                                                        </td>
                                                                        <td className="third-one">
                                                                            <div className="formgroup">
                                                                                <input onKeyUp={this.validateCommission} defaultValue={grouprow.comm} onChange={this.handleChange_overrides_commission} type="text" chIndex={index} className="form-control" name="commission" autoComplete="off" />
                                                                                <span>{grouprow.comm}</span>
                                                                                <input type="text" className="form-control defaultInput" defaultValue={grouprow.comm} name="Id" />
                                                                            </div>
                                                                        </td>
                                                                        {!this.state.isChecked ? <td className="fourth-one">
                                                                            <input type="button" className="btn save" onClick={this.saveData} value="Save" />
                                                                            <input type="button" onClick={this.handlecancel} className="btn cancel" value="Cancel" />
                                                                            <img src={EditIcon} onClick={this.handleEdit} className="editIcon" alt="editIcon" style={{ cursor: 'pointer' }} />
                                                                            <img src={DeleteIcon} onClick={(e) => this.cancelList(e, index)} className="deleteIcon" alt="deleteIcon" style={{ cursor: 'pointer' }} />
                                                                        </td> : null}
                                                                    </tr>
                                                                )}
                                                        </tbody>
                                                    </table>
                                                    : <span className="no-override-added">No pharmacy chain added yet</span>
                                            }
                                        </React.Fragment>
                                    </div>
                                </div>

                                <div className="button-section override-btn-section">
                                    {btnLoader &&
                                        <div className="theme-loader animated-loader" style={{ top: '-24px' }}></div>
                                    }
                                    <input disabled={disabled} type="button" onClick={this.handleSaveSubmit} className={btnLoader ? 'btn save animated-btn' : 'btn save'} value="Save & Submit" />
                                    <input disabled={disabled} type="button" onClick={this.handleClose} className="btn cancel" value="Cancel" />
                                    {(error || this.state.error) &&
                                        <div className={'error'}>{error || this.state.error}</div>
                                    }
                                    {(successMsg) &&
                                        <div className={'success'}>{successMsg}</div>
                                    }
                                </div>
                            </div>
                        </form>
                    </div>



                    {/*this.state.showGroupSection && <GroupSection WhName={this.props.whName} WhId={this.props.whId} onClose={this.handleCloseGroupSection} />*/}
                </div>
            </div>
        )
    }
}
export default AddOverride;